import { render, staticRenderFns } from "./tipo-deficiencia-component.vue?vue&type=template&id=b513a06a&"
import script from "./tipo-deficiencia-component.vue?vue&type=script&lang=ts&"
export * from "./tipo-deficiencia-component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b513a06a')) {
      api.createRecord('b513a06a', component.options)
    } else {
      api.reload('b513a06a', component.options)
    }
    module.hot.accept("./tipo-deficiencia-component.vue?vue&type=template&id=b513a06a&", function () {
      api.rerender('b513a06a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/component/tipo-deficiencia-component.vue"
export default component.exports